import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  useEffect(() => {
    // Kør iubenda loader til links
    if (typeof window !== 'undefined') {
      const loader = function () {
        const s = document.createElement('script')
        const tag = document.getElementsByTagName('script')[0]
        s.src = 'https://cdn.iubenda.com/iubenda.js'
        if (tag && tag.parentNode) {
          tag.parentNode.insertBefore(s, tag)
        } else {
          document.head.appendChild(s)
        }
      }
      loader()
    }
  }, [])

  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-800/80 pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 pb-12 border-b border-slate-800">
          {/* Col 1: Brand & Logo */}
          <div className="space-y-4">
            <Link to="/" className="inline-block" aria-label="Krüger Wet Blaster ApS">
              <img
                src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/kruger-logo-negativ.svg"
                alt="Krüger Wet Blaster"
                className="h-12 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200 mb-4">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-sky-400 transition-colors">
                  Forside
                </Link>
              </li>
              <li>
                <Link to="/produkter" className="hover:text-sky-400 transition-colors">
                  Produkter
                </Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-sky-400 transition-colors">
                  Om os
                </Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-sky-400 transition-colors">
                  Galleri
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-sky-400 transition-colors">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/bestil" className="hover:text-sky-400 transition-colors text-sky-400 font-medium">
                  Bestil produkt (Faktura)
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Produktkategorier */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200 mb-4">
              Produktkategorier
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/produkter?kategori=kabiner"
                  className="hover:text-sky-400 transition-colors"
                >
                  Kabiner
                </Link>
              </li>
              <li>
                <Link
                  to="/produkter?kategori=vandpoleringsmaskiner"
                  className="hover:text-sky-400 transition-colors"
                >
                  Vandpoleringsmaskiner
                </Link>
              </li>
              <li>
                <Link
                  to="/produkter?kategori=mobile-blaesere"
                  className="hover:text-sky-400 transition-colors"
                >
                  Mobile Blæsere
                </Link>
              </li>
              <li>
                <Link
                  to="/produkter?kategori=kompressorer"
                  className="hover:text-sky-400 transition-colors"
                >
                  Kompressorer
                </Link>
              </li>
              <li>
                <Link
                  to="/produkter?kategori=toerisblaesning"
                  className="hover:text-sky-400 transition-colors"
                >
                  Tørisblæsning
                </Link>
              </li>
              <li>
                <Link
                  to="/produkter?kategori=forbrugsmaterialer"
                  className="hover:text-sky-400 transition-colors"
                >
                  Forbrugsmaterialer & Kemi
                </Link>
              </li>
              <li>
                <Link
                  to="/produkter?kategori=reservedele-tilbehoer"
                  className="hover:text-sky-400 transition-colors"
                >
                  Reservedele & Tilbehør
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Virksomhedsoplysninger */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-wider text-slate-200 mb-4">
              Virksomhedsinformation
            </h3>
            <div className="space-y-3 text-sm">
              <div className="font-semibold text-slate-100">
                Krüger Wet Blaster ApS
              </div>
              <div className="flex items-start gap-2.5">
                <i className="fa-solid fa-location-dot text-sky-400 mt-1" aria-hidden="true" />
                <span>Erhvervsvej 1, 6650 Brørup</span>
              </div>
              <div className="flex items-center gap-2.5">
                <i className="fa-solid fa-phone text-sky-400" aria-hidden="true" />
                <a
                  href="tel:+4521438149"
                  className="hover:text-sky-400 transition-colors font-medium text-slate-200 whitespace-nowrap"
                >
                  21 43 81 49
                </a>
              </div>
              <div className="flex items-center gap-2.5">
                <i className="fa-solid fa-envelope text-sky-400" aria-hidden="true" />
                <a
                  href="mailto:jonkrygerpetersen@gmail.com"
                  className="hover:text-sky-400 transition-colors text-slate-200 whitespace-nowrap"
                >
                  jonkrygerpetersen@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom copyright */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-4">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <span>© {currentYear} Krüger Wet Blaster ApS. Alle rettigheder forbeholdes.</span>
            <span className="hidden sm:inline text-slate-700">·</span>
            <span>CVR: 41047216</span>
            <span className="hidden sm:inline text-slate-700">·</span>
            <a
              href="https://www.iubenda.com/privacy-policy/55130380"
              className="iubenda-white iubenda-noiframe iubenda-embed"
              title="Privatlivspolitik "
            >
              Privatlivspolitik
            </a>
            <span className="hidden sm:inline text-slate-700">·</span>
            <a
              href="https://www.iubenda.com/privacy-policy/55130380/cookie-policy"
              className="iubenda-white iubenda-noiframe iubenda-embed"
              title="Cookiepolitik "
            >
              Cookiepolitik
            </a>
          </div>
          <div className="flex items-center gap-2 text-slate-400">
            <span>Dansk ingeniørkunst & maskinproduktion</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
